export const EDGE_STYLE = { stroke: '#374151' };
export const DEFAULT_STEP_HEIGHT = 150;
export const OVERLAPPING_EDGE_STEP_INCREMENT = 10;

export const PERSON_NODE_DIMENSIONS = {
  width: 80,
  height: 80,
};

export const RELATIONSHIP_NODE_DIMENSIONS = {
  width: 12,
  height: 12,
};
